<div class="lkBreadcrumb alignVerticalMiddle">
  <ng-container *ngFor="let menuItem of breadCrumbList">
    <li>
    <span class="lkBreadcrumbSpanPointer" (click)="breadCrumbOnClick(menuItem.path)">
      {{menuItem.text}}
    </span>
    </li>
  </ng-container>
</div>
